import { render } from "./OptionImage.vue?vue&type=template&id=d713700e"
import script from "./OptionImage.vue?vue&type=script&lang=js"
export * from "./OptionImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__